import * as React from 'react';
import { Video } from '@grandvisionhq/content';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import '@swc/helpers';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';

const CmsVideo = ({ component  })=>{
    const { coverImage  } = component.getModels();
    const { videoUrl  } = component.getParameters();
    if (!videoUrl) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Video, {
        videoUrl: videoUrl,
        coverImage: coverImage
    });
};
var CmsVideo$1 = compose(withBreakpointVisibility, withAnchor)(CmsVideo);

export { CmsVideo, CmsVideo$1 as default };
//# sourceMappingURL=Video.js.map
